import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  try {
    await Auth.currentAuthenticatedUser();
    return true;
  } catch {
    await authService.signOut();
    sessionStorage.setItem('redirectAfterLogin', state.url);
    router.navigate(['/login']);
    return false;
  }
};
